import {
  ISearchCatalogItemSchema,
} from '@cian/api-models/monolith-python/cian-api/site/v1/get-region-cities';
export enum ERegionCitiesActions {
  set = 'set/regionCities',
  clear = 'clear/regionCities',
}

export interface IRegionCitiesAction {
  type: ERegionCitiesActions;
  data: ISearchCatalogItemSchema[];
}

export interface IRegionCitiesClearAction {
  type: ERegionCitiesActions;
}

export function setRegionCities(regionCitiesData: ISearchCatalogItemSchema[]) {
  return {
    data: regionCitiesData,
    type: ERegionCitiesActions.set,
  };
}

export function clearRegionCities() {
  return {
    type: ERegionCitiesActions.clear,
  };
}
